import { Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import FlexContainer from "../../components/containers/FlexContainer";
import PasswordFields from "../../domains/person/components/PasswordFields";
import { useSetPassword } from "../../domains/session/services/sessionServices";
import { useLangLabels } from "../../shared/lang/services/useLangLabels";
import { USER_ROUTES } from "../../shared/routes/routes";
import LoginFormContainer from "./components/LoginFormContainer";

const ResetPasswordPage: React.FC<{}> = () => {
  const { lang } = useLangLabels();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { mutate, status } = useSetPassword();

  const [done, setDone] = useState(false);

  const handleSubmit = (password: string) => {
    if (!token) return;
    mutate({ token, newPassword: password }, { onSuccess: () => setDone(true) });
  };

  return (
    <LoginFormContainer size="md">
      <FlexContainer flexDirection="column" gap="16px" align="center" padding="0px 16px 16px">
        <Typography variant="h6" align="center">
          {lang.passwordRecovery.reset.title}
        </Typography>

        {!token ? (
          <Alert style={{ width: "100%", boxSizing: "border-box" }} severity="error">
            {lang.passwordRecovery.reset.missingToken}
          </Alert>
        ) : done ? (
          <>
            <Alert style={{ width: "100%", boxSizing: "border-box" }} severity="success">
              {lang.passwordRecovery.reset.successMessage}
            </Alert>
            <Link to={`/${USER_ROUTES.login}`}>{lang.passwordRecovery.backToLogin}</Link>
          </>
        ) : (
          <PasswordFields
            onSave={handleSubmit}
            saveStatus={status === "loading" ? "loading" : undefined}
            saveLabel={lang.passwordRecovery.reset.submitButton}
            saveStyleProps={{ height: "40px" }}
          >
            {status === "error" ? (
              <Alert style={{ width: "100%", boxSizing: "border-box" }} severity="error">
                {lang.passwordRecovery.reset.errorMessage}
              </Alert>
            ) : null}
          </PasswordFields>
        )}
      </FlexContainer>
    </LoginFormContainer>
  );
};

export default ResetPasswordPage;
